import {BASE_API_URL} from 'config';
import {getQueryString} from 'utils/queryString';

export const searchUsers = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const url = `${BASE_API_URL}user/filterByParams?role=${action.role}&searchKey=${action.searchKey}&pageSize=${action.pageSize}&pageNumber=${action.pageNumber}`;

  const response = await fetch(url, {
    method: 'GET',
    headers,
  }).then((res) => res.json());

  return response.users;
};

export const searchCompanies = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const url = `${BASE_API_URL}company?searchKey=${action.searchKey}&renderGroupCountry=true`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
  }).then((res) => res.json());

  return response.companies;
};

export const assignCategories = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });
  let url = `${BASE_API_URL}category/${action.id}/assignpost?pageFolderId=${action.pageFolderId}&postId=${action.postId}`;
  if (action.isRemove) {
    url += `&isRemove=true`;
  }
  const response = await fetch(url, {
    method: 'PUT',
    headers,
  }).then((res) => res.json());

  return response.category;
};

export const verifySlug = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const url = `${BASE_API_URL}post/verifySlug/${action.slug}`;

  const response = await fetch(url, {
    method: 'GET',
    headers,
  }).then((res) => res.json());

  return response.isSlugExist;
};
export const linkFilesToPost = async ({postId, fileIds, authToken}) => {
  const url = `${BASE_API_URL}file/link`;

  // Obj of data to send in future like a dummyDb
  const data = {postId, fileIds};

  // POST request with body equal on data in JSON format
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  }).then((response) => response.json());

  // const headers = new Headers({
  //     ContentType: 'application/json',
  //     // "Content-Type": "application/json",
  //     Authorization: `Bearer ${authToken}`,
  // });
  // const body = JSON.stringify({
  //     postId, fileIds
  // });
  // // const body ={postId, fileIds};
  // console.log({postId, fileIds}, body);
  // const response = await fetch(url, {
  //     method: 'POST',
  //     body,
  //     headers,
  // });
  // console.log(response);
};
export const uploadServerFile = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
  });

  const formData = new FormData();
  formData.append('file', action.file);

  const url = `${BASE_API_URL}post/${action.postId}/upload`;

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });

  return response;
};
export const deleteServerFile = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const url = `${BASE_API_URL}document/${action.fileId}`;

  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  }).then((res) => res.json());
  console.log('deleteServerFile', response);
  return response;
};

export const uploadLogo = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
  });

  const formData = new FormData();
  formData.append('file', action.file);

  let url = `${BASE_API_URL}${action.type}/upload`;
  if (action.pageType) {
    url += `?type=${action.pageType}`;
  }

  if (action.pageFolderId) {
    url += `${url.indexOf('?type') > -1 ? '&' : '?'}pageFolderId=${
      action.pageFolderId
    }`;
  }

  if (action.folderId) {
    url += `${url.indexOf('?') > -1 ? '&' : '?'}folderId=${action.folderId}`;
  }

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });

  return response;
};

export const uploadUserLogo = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
  });

  const formData = new FormData();
  formData.append('file', action.file);
  const url = action.default
    ? `${BASE_API_URL}user/logo?default=true`
    : `${BASE_API_URL}user/logo`;
  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });

  return response;
};

export const getCategoryLogos = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const params = getQueryString(action.filters);
  const url = `${BASE_API_URL}${action.type}/logos?${params}`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
  }).then((res) => res.json());

  return response.logos.filter((f) => f.folderType === 'FILE');
};

export const getUserLogos = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const url = `${BASE_API_URL}user/logos?searchKey=${action.searchKey}`;

  const response = await fetch(url, {
    method: 'GET',
    headers,
  }).then((res) => res.json());

  return response.logos;
};

export const createFolder = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const params = getQueryString(action.filters);

  const URL = `${BASE_API_URL}company/${action.companyId}/folder?${params}`;
  const response = await fetch(URL, {
    method: 'POST',
    headers,
    body: JSON.stringify(action.details),
  }).then((res) => res.json());
  return response.folder;
};

export const createDocumentFolder = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const params = getQueryString(action.filters);

  const URL = `${BASE_API_URL}document/${action.companyId}/folder?${params}`;
  const response = await fetch(URL, {
    method: 'POST',
    headers,
    body: JSON.stringify(action.details),
  }).then((res) => res.json());
  return response.folder;
};

export const uploadFileToFolder = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
  });

  const formData = new FormData();
  formData.append('file', action.file);
  console.log('uploadFileToFolder', action);
  let url = `${BASE_API_URL}company/`;
  if (action.postId) {
    url = `${BASE_API_URL}post/${action.postId}/upload?isOuterFile=${action.isOuterFile}`;
  } else if (action.folderId) {
    url += `${action.folderId}/file`;
  } else if (action.companyId) {
    url += `${action.companyId}/file?isOuterFile=${action.isOuterFile}`;
  } else {
    return false;
  }
  if (action.isChatFile) {
    url += `&isChatFile=true`;
  }
  if (action.parentId) {
    url +=
      url.indexOf('?') > -1
        ? `&parentId=${action.parentId}`
        : `?parentId=${action.parentId}`;
  }

  url += `${url.indexOf('?') === -1 ? '?' : '&'}categoryType=${
    action.categoryType
  }&action=upload`;

  url += `&queryCompanyId=${action.queryCompanyId}`;

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });

  return response;
};

export const uploadFileToDocument = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
  });

  const formData = new FormData();
  formData.append('file', action.file);

  let url = `${BASE_API_URL}document/`;
  if (action.folderId) {
    url += `${action.folderId}/file`;
    if (action.isChatFile) {
      url += `?isChatFile=true`;
    }
  } else {
    url += `${action.companyId}/file?isOuterFile=true`;
    if (action.isChatFile) {
      url += `&isChatFile=true`;
    }
  }

  if (action.parentId) {
    url +=
      url.indexOf('?') > -1
        ? `&parentId=${action.parentId}`
        : `?parentId=${action.parentId}`;
  }

  url += `${url.indexOf('?') === -1 ? '?' : '&'}categoryType=${
    action.categoryType
  }&action=upload`;

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });

  return response;
};

export const addCompany = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const url = `${BASE_API_URL}company`;

  return fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(action.details),
  });
};

export const searchFolders = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const params = getQueryString(action.filters);

  const requestUrl = `${BASE_API_URL}company/${action.companyId}/folders?${params}`;

  const response = await fetch(requestUrl, {
    method: 'GET',
    headers,
  }).then((res) => res.json());

  return response.folders;
};

export const searchDocuments = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const params = getQueryString(action.filters);

  const requestUrl = `${BASE_API_URL}document/folders?${params}`;

  const response = await fetch(requestUrl, {
    method: 'GET',
    headers,
  }).then((res) => res.json());

  return response.folders;
};

export const getPosts = async (action) => {
  const params = getQueryString(action.filters);
  const requestUrl = `https://${action.folder}.jidipi.com/wp-admin/admin-ajax.php?${params}`;
  const response = await fetch(requestUrl, {
    method: 'GET',
  }).then((res) => res.json());

  return response.postList;
};

export const updatePost = async (action) => {
  const params = getQueryString(action.filters);
  const requestUrl = `https://${action.folder}.jidipi.com/wp-admin/admin-ajax.php?${params}`;
  const response = await fetch(requestUrl, {
    method: 'GET',
  }).then((res) => res.json());
  return response.folders;
};

export const importPost = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const requestUrl = `${BASE_API_URL}post/import`;

  const response = await fetch(requestUrl, {
    method: 'POST',
    headers,
    body: JSON.stringify(action.details),
  }).then((res) => res.json());

  return response;
};

export const importCategoriesList = async (action) => {
  const headers = new Headers({
    Authorization: `Bearer ${action.authToken}`,
    'Content-Type': 'application/json',
  });

  const params = getQueryString(action.filters);
  const url = `${BASE_API_URL}category/import?${params}`;
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(action.details),
  }).then((res) => res.json());

  return response.logos;
};
